const bfsProblems = [
  {
      title: "BinaryTree Level Order Traversal",
      url: "https://leetcode.com/problems/binary-tree-level-order-traversal/"
    },
    {
      title: "Number of Islands",
      url: "https://leetcode.com/problems/number-of-islands/"
    },
    {
      title: "Minimum Depth of BinaryTree",
      url: "https://leetcode.com/problems/minimum-depth-of-binary-tree/"
    },
    {
      title: "Rotting Oranges",
      url: "https://leetcode.com/problems/rotting-oranges/"
    },
    {
      title: "Word Ladder",
      url: "https://leetcode.com/problems/word-ladder/"
    }
];
export default bfsProblems;